import React, { Component } from 'react';
import { validateMobile } from '../../utils/commonFunctions.js';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
	updateProfileDetails,
	onPhoneChange,
	onEmailChange,
	onFullNameChange,
	setGetUserInfo,
} from '../../redux/profile/profile.actions';
import Modal from 'react-bootstrap/Modal';
import { setErrorPanel } from '../../redux/utilities/utils.actions';

class UserInfoModal extends Component {
	constructor(props) {
		super(props);
		this.updateInfo = this.updateInfo.bind(this);
		this.ignoreUpdate = this.ignoreUpdate.bind(this);
	}

	ignoreUpdate() {
		localStorage.setItem('ignoreUpdateTime', Date());
		this.props.setGetUserInfo(false);
	}

	updateInfo() {
		const {
			phone,
			fullName,
			email,
			updateProfileDetails,
			isCoachCall,
			setErrorMsg,
		} = this.props;

		let validatePhone = validateMobile(phone);

		if (validatePhone.length > 0) {
			setErrorMsg({
				panelClass: 'alert alert-danger',
				panelMsg: validatePhone,
			});
		} else if (isCoachCall && !email) {
			setErrorMsg({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter your email.',
			});
		} else if (isCoachCall && !fullName) {
			setErrorMsg({
				panelClass: 'alert alert-danger',
				panelMsg: 'Please enter your full name.',
			});
		} else {
			setErrorMsg({
				panelClass: '',
				panelMsg: '',
			});
			updateProfileDetails({
				phone,
				email,
				is_olympiad: 'yes',
				full_name: fullName,
				isCoachCall,
			});
		}
	}

	render() {
		let {
			isCoachCall,
			title,
			onPhoneChange,
			onEmailChange,
			onFullNameChange,
			phone,
			fullName,
			email,
			error: { panelClass, panelMsg },
			getUserInfo,
		} = this.props;

		return (
			<Modal
				show={getUserInfo}
				dialogClassName="modal-90w"
				onHide={this.ignoreUpdate}
				backdrop="static"
				keyboard={false}
			>
				<Modal.Header closeButton>{title}</Modal.Header>
				<Modal.Body size="lg">
					<div className={panelClass}>{panelMsg}</div>

					<form>
						<div className="form-group">
							<input
								type="text"
								className="form-control"
								defaultValue={phone}
								onChange={onPhoneChange}
								id="txtOlyMobile"
								name="phone"
								placeholder="Phone*"
								required=""
							/>
						</div>
						<div className="form-group">
							<input
								type="text"
								className="form-control"
								id="txtOlyEmail"
								name="email"
								onChange={onEmailChange}
								placeholder={`Email${isCoachCall ? '*' : ''}`}
								defaultValue={email}
							/>
						</div>
						{isCoachCall ? (
							<div className="form-group">
								<input
									type="text"
									className="form-control"
									defaultValue={fullName}
									onChange={onFullNameChange}
									id="txtFullName"
									name="fullName"
									placeholder="Full Name*"
								/>
							</div>
						) : null}
						<div className="form-group text-right">
							<button
								aria-label="submit"
								id="button"
								type="button"
								value="test"
								className="btn btn-primary"
								onClick={() => {
									this.updateInfo();
								}}
							>
								Submit
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		);
	}
}

const mapStateToProps = (state) => {
	const { profileDetails, utils, userDetails } = state.rootReducer;
	return {
		phone: profileDetails.phone || userDetails.phone,
		fullName: profileDetails.fullName || userDetails.fullName,
		email: profileDetails.email || userDetails.email,
		error: utils.errorPanel,
		success: profileDetails.success,
		getUserInfo: profileDetails.getUserInfo,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateProfileDetails: (value) => dispatch(updateProfileDetails(value)),
		onPhoneChange: (event) => dispatch(onPhoneChange(event.target.value)),
		onEmailChange: (event) => dispatch(onEmailChange(event.target.value)),
		onFullNameChange: (event) => dispatch(onFullNameChange(event.target.value)),
		setErrorMsg: (obj) => dispatch(setErrorPanel(obj)),
		setGetUserInfo: (obj) => dispatch(setGetUserInfo(obj)),
	};
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(
	UserInfoModal,
);
